import React, { useState, useEffect, forwardRef } from 'react';
import moment from 'moment';
import styles from './Projects.module.css';
import { years } from '../../helpers';
import YearSelect from '../common/YearSelect';
import Select from 'react-select';
import Accordion from '../Accordion';
import MaterialTable, { MTableHeader, MTableBody } from 'material-table';
import { TableCell, TableRow, TableFooter } from '@material-ui/core';
import Doughnut from '../Charts/Doughnut';
import useAPI from '../../hooks/useAPI';
import { modifyDefaultOptions } from '../../helpers/table';
import { Button } from "react-bootstrap";
import LoadingTable from "../table/LoadingTable";
import { floatRenderer, formatTripleSpaced } from '../../services/formatSvc';

export default function TabProjects() {
  const [year, setYear] = useState(moment().year());
  const api = useAPI();
  const [projs, setProjs] = useState();
  const [table1, setTable1] = useState([]);
  const [table2, setTable2] = useState([]);
  const [doughnutDataTypes, setDoughnutDataTypes] = useState({});
  const [doughnutDataParticipants, setDoughnutDataParticipants] = useState({});
  const [filterState, setFilterState] = useState();
  const [filterOptions, setFilterOptions] = useState();
  const [filterOptionsForSelect, setFilterOptionsForSelect] = useState();
  const [filterKeys, setFilterKeys] = useState();
  const [loadingDoughnuts, setLoadingDoughnuts] = useState(false);
  const [loading, setLoading] = useState(false);
  const [prevYearProjs, setPrevYearProjs] = useState();

  const isNew = year >= 2025;

  const columnsTable1 = [
    {
      title: '№',
      cellStyle: { width: '0%', maxWidth: '0px', padding: '0 12px 0 6px' },
      headerStyle: { padding: '0 12px 0 6px' },
      sorting: false,
      render: (rowData) => <span style={{ display: "block" }}>{rowData.hasOwnProperty('parentId') ? '' : `${rowData?.tableData?.path[0] + 1}.`}</span>
    },
    {
      title: 'Стратегический проект/ цель',
      cellStyle: { minWidth: "500px", paddingLeft: 0 },
      headerStyle: { paddingLeft: 0 },
      field: 'name',
      sorting: false,
    },
    {
      title: 'Утверждено по проектам (грант), руб.',
      cellStyle: { textAlign: 'center' },
      headerStyle: { textAlign: 'center' },
      field: 'planFbSum',
      sorting: false,
      render: (rowData) => <span style={{ display: "block" }}>{rowData.planFbSum ? formatTripleSpaced(floatRenderer(rowData.planFbSum)) : '-'}</span>
    },
    {
      title: 'Утверждено по проектам (СФ), руб.',
      cellStyle: { textAlign: 'center' },
      headerStyle: { textAlign: 'center' },
      field: 'planSfSum',
      sorting: false,
      render: (rowData) => <span style={{ display: "block" }}>{rowData.planSfSum ? formatTripleSpaced(floatRenderer(rowData.planSfSum)) : '-'}</span>
    },
    !isNew && {
      title: 'Плановое количество проектов',
      cellStyle: { textAlign: 'center' },
      headerStyle: { textAlign: 'center' },
      field: 'planCount',
      sorting: false,
      render: (rowData) => <span style={{ display: "block" }}>{rowData.planCount ? rowData.planCount : '-'}</span>
    },
    {
      title: 'Одобренные проекты',
      cellStyle: { textAlign: 'center' },
      headerStyle: { textAlign: 'center' },
      field: 'factCount',
      sorting: false,
      render: (rowData) => <span style={{ display: "block" }}>{rowData.factCount ? rowData.factCount : '-'}</span>
    },
    {
      title: 'Количество участников',
      cellStyle: { textAlign: 'center' },
      headerStyle: { textAlign: 'center' },
      field: 'teamMemberCount',
      sorting: false,
      render: (rowData) => <span style={{ display: "block" }}>{rowData.teamMemberCount ? rowData.teamMemberCount : '-'}</span>
    }
  ].filter(column => column !== false && typeof column === 'object');

  const columnsTable2 = [
    {
      title: 'Тип',
      cellStyle: { minWidth: "500px" },
      field: 'name',
      sorting: false,
      render: (rowData) => rowData.hasOwnProperty('parentId') ? <span style={{ paddingLeft: '8px' }}>{rowData?.name}</span> : <span style={{ fontWeight: '600' }}>{rowData?.name}</span>
    },
    {
      title: 'Плановое количество проектов',
      cellStyle: { textAlign: 'center' },
      headerStyle: {textAlign: 'center'},
      field: 'planCount',
      sorting: false,
      render: (rowData) => rowData.hasOwnProperty('parentId') ? <span>{rowData?.planCount ? rowData.planCount : '-'}</span> : <span style={{ fontWeight: '600' }}>{rowData?.planCount ? rowData.planCount : '-'}</span>
    },
    {
      title: 'Одобренные проекты',
      cellStyle: { textAlign: 'center' },
      headerStyle: {textAlign: 'center'},
      field: 'factCount',
      sorting: false,
      render: (rowData) => rowData.hasOwnProperty('parentId') ? <span>{rowData?.factCount ? rowData.factCount : '-'}</span> : <span style={{ fontWeight: '600' }}>{rowData?.factCount ? rowData.factCount : '-'}</span>
    },
    isNew && {
      title: 'Бюджет, млн руб.',
      cellStyle: { textAlign: 'center' },
      headerStyle: {textAlign: 'center'},
      field: 'planSum',
      sorting: false,
      render: (rowData) => rowData.hasOwnProperty('parentId') ? 
        <span>{rowData?.planSum ? formatTripleSpaced(floatRenderer(rowData.planSum)) : '-'}</span> : 
        <span style={{ fontWeight: '600' }}>{rowData?.planSum ? formatTripleSpaced(floatRenderer(rowData.planSum)) : '-'}</span>
    },
  ].filter(column => column !== false && typeof column === 'object');

  useEffect(async () => {
    setTable1([]);
    setTable2([]);
    setProjs(null);
    setLoading(false);
    setPrevYearProjs(null);

    const projstResp = await api.get(`/stats/projs?year=${year}`);
    const prevYearProjsResp = await api.get(`/stats/projs?year=${year - 1}`);

    setTable1(projstResp.byStrategies);
    setTable2(projstResp.byFunding);
    setProjs(projstResp);
    setPrevYearProjs(prevYearProjsResp);
    setLoading(true);
  }, [year]);

  const getDoughnutsData = async () => {
    const filterKeysSection = filterKeys ? `&filter=` + JSON.stringify(filterKeys) : '';
    const doughnutRespByTypes = await api.get(`/stats/projs/types?year=${year}${filterKeysSection}`);
    const doughnutRespByParticipants = await api.get(`/stats/teamMembers?year=${year}${filterKeysSection}`);

    let sumTypes = 0;
    let sumParticipants = 0;

    const doughnutDataTypes = {
      summary: 0,
      labels: [
        'Научный',
        'Организационный',
        'Инфраструктурный',
        'Образовательный',
        'Предпринимательство и инновации',
        'Социальный',
        'Цифровая трансформация',
        'Учебно-методический',
      ],
      datasets: [
        {
          label: 'Всего проектов',
          data: [0, 0, 0, 0, 0, 0, 0, 0],
          dataPersons: [0, 0, 0, 0, 0, 0, 0, 0],
          backgroundColor: [
            '#0A0052',
            '#BEBEBE',
            '#7585D1',
            '#C2D0EE',
            '#7F7F7F',
            '#305FFD',
            '#92B4FF',
            '#3420CA',
            '#DAD2F2',
            '#4312AE',
            '#8E6DD7',
            '#7446D7',
          ],
        },
      ],
    };
    const doughnutDataParticipants = {
      summary: 0,
      labels: [],
      datasets: [
        {
          label: 'Всего участников',
          data: [],
          backgroundColor: [
            '#0A0052',
            '#BEBEBE',
            '#7585D1',
            '#C2D0EE',
            '#7F7F7F',
            '#305FFD',
            '#92B4FF',
            '#3420CA',
            '#DAD2F2',
            '#4312AE',
            '#8E6DD7',
            '#7446D7',
          ],
        },
      ],
    };

    doughnutRespByTypes.byTypes
      .sort((a, b) => {
        if (a.factCount < b.factCount) return 1;
        return -1;
      })
      .map((e, i) => {
        doughnutDataTypes.datasets[0].data[i] = e.factCount;
        doughnutDataTypes.datasets[0].dataPersons[i] = e.hasOwnProperty('teamMemberCount') ? e.teamMemberCount : 0;
        doughnutDataTypes.labels[i] = e.name;
      });
    doughnutDataTypes.summary = doughnutRespByTypes.totalFactCount;
    doughnutRespByParticipants.byCategory
      .sort((a, b) => {
        if (a.factCount < b.factCount) return 1;
        return -1;
      })
      .map((e, i) => {
        doughnutDataParticipants.datasets[0].data[i] = e.factCount;
        doughnutDataParticipants.labels[i] = e.name;
      });
    doughnutDataParticipants.summary = doughnutRespByParticipants.totalTeamMemberCount;

    if (doughnutRespByTypes.totalFactCount === 0)
    doughnutDataTypes.datasets[0].data = new Array();
    if (doughnutRespByParticipants.totalTeamMemberCount === 0)
    doughnutDataParticipants.datasets[0].data = new Array();

    setDoughnutDataTypes(doughnutDataTypes);
    setDoughnutDataParticipants(doughnutDataParticipants);
    setLoadingDoughnuts(true);
  }

  useEffect(async () => {
    const filterVariants = await api.get(`/stats/projs/structure?year=${year}`);
    const filterVariantsForSelect = filterVariants.map((e) => ({ value: e.id, label: e.name }));
    setFilterOptions(filterVariants);
    setFilterOptionsForSelect([{value: 'all', label: 'По программе развития'}, ...filterVariantsForSelect]);
    setFilterState({ value: 'all', label: 'По программе развития' });
    filterKeys === '' ? getDoughnutsData() : setFilterKeys('');
  }, [year]);

  useEffect(async () => {
    filterKeys !== undefined && getDoughnutsData();
  }, [filterKeys]);

  const handleFilterChange = (e) => {
    setFilterState(e);
    const chosedOption = e.value === 'all' ? { filterKeys: null } : filterOptions.find((el) => el.id === e.value);
    setFilterKeys(chosedOption.filterKeys);
  }

  const pushToPage = () => {
    window.open('https://data.my1.urfu.ru/#/data/dashboards/p2030m', '_blank');
  }

  return (
    <div className={styles.projects}>
      <LoadingTable loadingObject={{isLoaded: loading}}>
        {projs && (
          <>
            <div className='general-stat-wrapper' style={{ alignItems: 'flex-start' }}>
              <div style={{ width: '170px', minWidth: '170px' }}>
                <YearSelect
                  year={year}
                  years={years}
                  onChange={(e) => setYear(e.value)}
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: props => ({ ...props, zIndex: 3 }) }}
                />
              </div>
              <div>
                <div className='general-stat-container'>
                  <div className='stat-container'>
                    <h2>{projs.totalPlanCount}</h2>
                    <p className='stat-title'>Плановое количество проектов</p>
                  </div>
                  <div className='stat-container'>
                    <h2>{projs.totalFactCount}</h2>
                    <p className='stat-title'>Одобренные проекты</p>
                  </div>
                  <div className='stat-container'>
                    <h2>{projs.totalTeamMemberCount}</h2>
                    <p className='stat-title'>Участники проектов</p>
                  </div>
                </div>
                <p style={{margin: '10px 0px'}}>Справочные значения {year - 1} года:</p>
                <div className='reference-stat-container'>
                  <div className='stat-container'>
                    <h2>{prevYearProjs?.totalPlanCount}</h2>
                    <p className='stat-title'>Плановое количество проектов</p>
                  </div>
                  <div className='stat-container'>
                    <h2>{prevYearProjs?.totalFactCount}</h2>
                    <p className='stat-title'>Одобренные проекты</p>
                  </div>
                  <div className='stat-container'>
                    <h2>{prevYearProjs?.totalTeamMemberCount}</h2>
                    <p className='stat-title'>Участники проектов</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="simple-table-style">
              <Accordion title="Детализация по стратегическим проектам/ целям">
                <MaterialTable
                  components={{
                    Header: (props) => (<MTableHeader {...props} style={{ position: 'sticky', fontSize: '18px' }}/>),
                    Body: (props) => (
                      <>
                        <MTableBody {...props} style={{ fontSize: '16px'}} />
                        {props.renderData.length > 0 && <TableFooter>
                          <TableRow>
                            <TableCell style={{border: 'none'}}></TableCell>
                            <TableCell style={{border: 'none'}}></TableCell>
                            <TableCell style={{color: '#212529', fontWeight: 700, fontSize: 14, border: 'none', paddingLeft: 0}}>Всего</TableCell>
                            <TableCell style={{color: '#212529', fontWeight: 700, fontSize: 14, border: 'none', textAlign: 'center'}}>{formatTripleSpaced(floatRenderer(projs.totalPlanFbSum))}</TableCell>
                            <TableCell style={{color: '#212529', fontWeight: 700, fontSize: 14, border: 'none', textAlign: 'center'}}>{formatTripleSpaced(floatRenderer(projs.totalPlanSfSum))}</TableCell>
                            {!isNew && <TableCell style={{color: '#212529', fontWeight: 700, fontSize: 14, border: 'none', textAlign: 'center'}}>{projs.totalPlanCount}</TableCell>}
                            <TableCell style={{color: '#212529', fontWeight: 700, fontSize: 14, border: 'none', textAlign: 'center'}}>{projs.totalFactCount}</TableCell>
                            <TableCell style={{color: '#212529', fontWeight: 700, fontSize: 14, border: 'none', textAlign: 'center'}}>{projs.totalTeamMemberCount}</TableCell>
                          </TableRow>
                        </TableFooter>}
                      </>
                    ),
                  }}
                  options={modifyDefaultOptions({
                    toolbar: false,
                    filtering: false,
                    maxBodyHeight: 'calc(100vh - 100px)',
                    headerStyle: { height: 56, zIndex: 0 },
                  })}
                  columns={columnsTable1}
                  data={table1}
                  icons={{DetailPanel: forwardRef((props, ref) =>
                    <svg width="17" height="17" viewBox="0 0 17 9" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>
                      <path style={{transform: 'rotate(-90deg)', transformOrigin: 'center center'}} fillRule="evenodd" clipRule="evenodd" d="M0 1.64067L1.35559 0.0996094L8.3905 5.57233L15.4254 0.0996094L16.781 1.64067L8.3905 8.16795L0 1.64067Z" fill="#000070"/>
                    </svg>
                  )}}
                  parentChildData={(row, rows) => rows.find((a) => a?.id === row?.parentId)}
                />
              </Accordion>
              <Accordion title="Детализация в разрезе гранта/ софинансирования">
                <MaterialTable
                  components={{
                    Header: (props) => (<MTableHeader {...props} style={{ position: 'sticky', fontSize: '18px' }}/>),
                    Body: (props) => (<MTableBody {...props} style={{ fontSize: '16px'}}/>),
                  }}
                  options={modifyDefaultOptions({
                    toolbar: false,
                    filtering: false,
                    maxBodyHeight: 'calc(100vh - 100px)',
                    headerStyle: { height: 56, zIndex: 0 },
                  })}
                  columns={columnsTable2}
                  data={table2}
                />
              </Accordion>
            </div>
            <div style={{display: 'flex', columnGap: '23px'}}>
              <div style={{ marginBottom: '20px' }}>
                <div style={{ width: '400px' }}>
                  <Select
                    options={filterOptionsForSelect}
                    onChange={(e) => handleFilterChange(e)}
                    value={filterState}
                    isSearchable={false}
                    menuPortalTarget={document.body}
                    styles={{ menuPortal: props => ({ ...props, zIndex: 3 }) }}
                  />
                </div>
              </div>
              <div style={{ marginBottom: '20px' }}>
                <div style={{ width: '400px' }}>
                  <Button variant="primary" onClick={pushToPage}>Дашборд «Участники проектов»</Button>
                </div>
              </div>
            </div>
            <LoadingTable loadingObject={{isLoaded: loadingDoughnuts}}>
              <div className='doughnuts-container'>
                <div>
                  <h3
                    className="left-aligned-no-icon"
                    style={{ marginBottom: '42px', fontSize: '20px' }}
                  >
                    Распределение проектов по типам к общему числу проектов
                  </h3>
                  <Doughnut data={doughnutDataTypes} title="Всего проектов" unit="шт."/>
                </div>
                <div>
                  <h3
                    className="left-aligned-no-icon"
                    style={{ marginBottom: '42px', fontSize: '20px' }}
                  >
                    Участники по категориям
                  </h3>
                  <Doughnut data={doughnutDataParticipants} title="Всего участников" unit="чел."/>
                </div>
              </div>
            </LoadingTable>
          </>
        )}
      </LoadingTable>
    </div>
  );
}
